import React from 'react';

function BookPreview({
  book,
  format,
  images,
  imageIndex,
  language,
  onLanguageChange,
  bundleCovers,
}) {
  const isBundle = book.isBundle;

  return (
    <div className={`book-preview ${isBundle ? 'bundle-preview' : ''}`}>
      <div className={`cover-stack ${isBundle ? 'bundle' : ''}`}>
        {isBundle ? (
          <>
            <img
              src={
                format === 'digital'
                  ? bundleCovers.digital[0]
                  : bundleCovers.paper[0]
              }
              alt="Before We Get Older"
            />

            <img
              src={
                format === 'digital'
                  ? bundleCovers.digital[1]
                  : bundleCovers.paper[1]
              }
              alt="The In-Between"
            />
          </>
        ) : (
          <img
            src={images[imageIndex]}
            alt={book.title}
          />
        )}
      </div>

      <div className="book-preview-info">
        <h2>{book.displayTitle || book.title}</h2>

        <p className="subtitle">{book.subtitle}</p>

        {book.hasArabic && (
          <div
            className="language-switch"
            role="group"
            aria-label="Choose book language"
          >
            <button
              type="button"
              className={`lang-btn ${
                language === 'en' ? 'active' : ''
              }`}
              aria-pressed={language === 'en'}
              onClick={() => onLanguageChange('en')}
            >
              English
            </button>

            <span className="lang-divider">|</span>

            <button
              type="button"
              className={`lang-btn ${
                language === 'ar' ? 'active' : ''
              }`}
              aria-pressed={language === 'ar'}
              onClick={() => onLanguageChange('ar')}
            >
              العربية
            </button>
          </div>
        )}

        <p className="author">by {book.author}</p>
      </div>
    </div>
  );
}

export default BookPreview;